export default __webpack_public_path__ + "media/images/svg/jump-dog-icon-d0417b16402ea05d68f7351abd2f23c4.svg";